import { createContext } from 'react';

// ----------------------------------------------------------------------
export type WorkspaceContextValue = {
  orgGuid: string;
  setOrgGuid: (orgGuid: string) => void;
};

export const WorkspaceContext = createContext<WorkspaceContextValue | undefined>(undefined);

export const WorkspaceConsumer = WorkspaceContext.Consumer;
